import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IonicModule } from '@ionic/angular';
import { OrdonnancesService } from './services/ordonnances.service';
import { PipeModule } from '../../pipes';

const components: Type<any>[] = [
];

@NgModule({
	exports: components,
	declarations: components,
	imports: [
		CommonModule,
		IonicModule,
		PipeModule,
		FormsModule,
		MatChipsModule,
		MatTooltipModule
	],
	providers: [OrdonnancesService]
})
export class OrdonnancesModule { }
